import { useCallback, type Dispatch, type SetStateAction } from "react";
import type { GitStatusResult } from "@cmmd-forge/contracts";

type GitChangedFile = GitStatusResult["workingTree"]["files"][number];

export function useGitFileSelectionActions(input: {
  readonly allFiles: readonly GitChangedFile[];
  readonly allSelected: boolean;
  readonly setExcludedFiles: Dispatch<SetStateAction<ReadonlySet<string>>>;
  readonly setIsEditingFiles: Dispatch<SetStateAction<boolean>>;
}) {
  const toggleEditingFiles = useCallback(() => {
    input.setIsEditingFiles((previous) => !previous);
  }, [input]);

  const toggleAllFiles = useCallback(() => {
    input.setExcludedFiles(
      input.allSelected ? new Set(input.allFiles.map((file) => file.path)) : new Set(),
    );
  }, [input]);

  const toggleFile = useCallback(
    (path: string) => {
      input.setExcludedFiles((previous) => {
        const next = new Set(previous);
        if (next.has(path)) {
          next.delete(path);
        } else {
          next.add(path);
        }
        return next;
      });
    },
    [input],
  );

  return { toggleEditingFiles, toggleAllFiles, toggleFile };
}
